export const rubyApiBaseRoute = process.env.REACT_APP_API_BASE_URL || '';
export const rubyOrderRoute = `${rubyApiBaseRoute}/orders-v2/api/v1`;
export const fileBaseRoute = rubyApiBaseRoute.replace('api/v1', '');
export const apiAuthRoute = process.env.REACT_APP_API_AUTH_URL || '';
export const apiCentralRoute = `${rubyApiBaseRoute}`;
export const apiCreditRoute = `${rubyApiBaseRoute}/wrapper`;
export const apiNotificationsRoute = `${rubyApiBaseRoute}/notifications`;
export const apigatewayBaseRoute = `${process.env.REACT_APP_EXTAPI_BASE_URL ?? ''}/ufo`;
export const loginRoute = '/api/login';
export const listOrdersRoute = '/orders-v2/api/v1';
export const apiBaseRouteDefault = process.env.REACT_APP_API_BASE_URL ?? '';
export const rubyBaseRouteDefault = `${apiBaseRouteDefault}${listOrdersRoute}`;
